import helpers from '../../util/helpers';

const venuesSliderTable = () => {
  jQuery(document).ready(function($) {
    const viewLayoutItems = $('.section-hotel-venue-slider .view-layout-item');
    if (viewLayoutItems.length) {
      viewLayoutItems.on('click', function(e) {
        e.preventDefault();

        const _this = $(this);
        const selectedView = _this.data('view');

        viewLayoutItems.removeClass('active');
        _this.addClass('active');

        const gridContent = $('.section-hotel-venue-slider .hotel-venue-slider-grid-content');
        const tableContent = $('.section-hotel-venue-slider .hotel-venue-slider-table-content');

        if (selectedView === 'grid') {
          gridContent.show();
          tableContent.hide();
          $('.section-hotel-venue-slider .slider').slick('setPosition');
        } else if (selectedView === 'table') {
          gridContent.hide();
          tableContent.show();
        }

        return false;
      });
    }

    const slider = $('.section-hotel-venue-slider .slider');
    if (slider.length) {
      slider.on('init', function() {
        helpers.equalHeightElements('.slider .equal-height');
      });

      slider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        mobileFirst: true,
        prevArrow: $('.section-hotel-venue-slider .prev'),
        nextArrow: $('.section-hotel-venue-slider .next'),
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }
  });
};

export default venuesSliderTable;



// WEBPACK FOOTER //
// ./scripts/routes/modules/venuesSliderTable.js